import { CompanyDebt } from "@models/companies/company-debt";

export class CompanyDebtExtended extends CompanyDebt {
    companyName: string = '';
    name: string = '';
    acn: string = '';

    constructor(debt: Partial<CompanyDebtExtended> = {}) {
        super(debt);
        this.companyName = debt.companyName ?? '';
        this.name = debt.companyName ?? '';
        this.acn = debt.acn ?? '';
    }
}
